import { useQuery } from '@apollo/client';
import { GET_CREATIVE_PACKAGE_IMAGE } from '../../graphql/queries/creativeQueries';
import { useMemo } from 'react';
import { getCloudFrontImageUrl } from '../../util/cloudFrontUtils';
import awsConfig from '../../config/aws-config';

/**
 * Hook to fetch the first image from a creative package
 * @param {string} packageId - The Package ID
 * @returns {object} - { firstImage, packageName, loading, error }
 */
export const useFetchCreativePackageImage = (packageId) => {
  const { data, loading, error } = useQuery(GET_CREATIVE_PACKAGE_IMAGE, {
    variables: { id: packageId },
    skip: !packageId,
    fetchPolicy: 'cache-and-network',
  });

  const processedData = useMemo(() => {
    if (!data?.getCreativePackage) return { firstImage: null, packageName: null };

    const pkg = data.getCreativePackage;
    let firstImage = null;

    // Get the first image from portfolioImages array
    if (pkg.portfolioImages && Array.isArray(pkg.portfolioImages) && pkg.portfolioImages.length > 0) {
      const firstImageKey = pkg.portfolioImages[0];
      if (firstImageKey) {
        try {
          firstImage = getCloudFrontImageUrl(firstImageKey, {
            width: 400,
            height: 300,
            fit: 'cover'
          });
        } catch (error) {
          try {
            const cleanKey = firstImageKey.startsWith('public/') ? firstImageKey : `public/${firstImageKey}`;
            firstImage = `https://${awsConfig.Storage.S3.bucket}.s3.${awsConfig.Storage.S3.region}.amazonaws.com/${cleanKey}`;
          } catch (fallbackError) {
            firstImage = null;
          }
        }
      }
    }

    return {
      firstImage,
      packageName: pkg.name || null
    };
  }, [data]);

  return {
    ...processedData,
    loading,
    error
  };
};

